import { useQuery } from '@tanstack/react-query';
import { getAxios } from 'src/lib/axios';
import { ObtFrontierUserContactModel } from '../ObtFrontierUserContactModel';
import { useAuth } from '@invara-dev/react-base';

export const useOnlineBookingFrontierUserContactsQuery = () => {
  const auth = useAuth();
  // NOTE - 'selectedUserId' isn't used here, because we're fetching the initial list itself.
  return useQuery({
    queryKey: ['useOnlineBookingFrontierUserContactsQuery'],
    queryFn: async () => {
      const data = await getAxios().get<ObtFrontierUserContactModel[]>(
        `/api/OnlineBookingFrontierUserContacts/GetOnlineBookingFrontierUserContacts`,
        {}
      );
      return data.data;
    },
    enabled: auth.isAuthenticated,
    networkMode: 'always'
  });
};
